import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ProductConfigurationScreen from 'screens/ProductConfiguration';
import { getProductById } from 'api/product';
import { setHelmetData, resetHelmet } from 'creatella-react-components/lib/reduxReducers/helmet';
import { connect } from 'react-redux';
import { imageFit } from 'utils/cloudinaryHelper';

class ProductConfiguration extends PureComponent {
    static propTypes = {
        location: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object,
        setHelmetData: PropTypes.func,
        resetHelmet: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            data: null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillUnmount() {
        this.props.resetHelmet();
    }

    loadData = async () => {
        const { match: { params: { slug } }, setHelmetData } = this.props;
        const extraTags = [];

        this.setState({ isLoading: true });

        try {
            const { data: { data } } = await getProductById(slug);

            extraTags.push(data.name);

            for (const tag of data.tags) {
                if (tag.visible) {
                    extraTags.push(tag.name);
                }
            }

            for (const item of data.variations) {
                if (item.tags.length !== 0) {
                    for (const tag of item.tags) {
                        if (tag.visible) {
                            extraTags.push(tag.name);
                        }

                        if (!item.name_inherited) {
                            extraTags.push(item.name);
                        }
                    }
                }
            }

            setHelmetData({
                title: data.name,
                description: data.short_description ? data.short_description : data.name,
                image: imageFit(data.medias.image[0].url, 260),
                extraTags: [<meta name='keywords' content={[...extraTags]} key={0} />]
            });

            this.setState({ data });
        } catch (err) {
            console.log('errerr', err);
        }

        this.setState({ isLoading: false });
    }

    render() {
        const { isLoading, data } = this.state;
        const { match: { params: { slug } }, history } = this.props;

        return (
            <ProductConfigurationScreen
                data={data}
                slug={slug}
                history={history}
                isLoading={isLoading} />
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    setHelmetData: data => dispatch(setHelmetData(data)),
    resetHelmet: () => dispatch(resetHelmet())
});

export default connect(null, mapDispatchToProps)(ProductConfiguration);
